<template>
  <div class="bg-white">
    <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Info Partner</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
          <p class="text-neutral-500 mdmax:break-all">{{ detail.id }}</p>
        </div>
        <div class="mb-6 flex gap-6">
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama</label>
            <p class="text-neutral-500">{{ detail.name }}</p>
          </div>
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No. Handphone</label>
            <p class="text-neutral-500">{{ detail.phone_number }}</p>
          </div>
        </div>
        <div class="mb-6 flex gap-6">
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Alamat Email</label>
            <p class="text-neutral-500">{{ detail.email }}</p>
          </div>
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Jumlah Armada</label>
            <p class="text-neutral-500">{{ detail.total_vehicle }}</p>
          </div>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Alamat</label>
          <p class="text-neutral-500">{{ detail.address }}</p>
        </div>
      </div>
      <div class="flex-1">
        <div class="p-6 shadow-border-b">
          <p class="font-bold text-lg mb-6">No. Rekening</p>
          <div class="flex gap-6">
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Bank</label>
              <p class="text-neutral-500">{{ bankData.name }}</p>
            </div>
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No. Rekening</label>
              <p class="text-neutral-500">{{ bankData.account }}</p>
            </div>
          </div>
        </div>
        <div class="p-6">
          <p class="font-bold text-lg mb-6">Dokumen</p>
          <label class="text-sm text-neutral-700 font-medium mb-1 block">KTP</label>
          <div class="border p-2 w-40 rounded-md inline-block">
            <a :href="detail.idcard_file_url" target="_blank">
              <img :src="detail.idcard_file_url" alt="KTP" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end mdmax:justify-center">
      <Button buttonText="Hapus" @action="toggleDeleteModal()" type="delete" :size="isMobile ? 'full' : 'regular'" />
      <Button buttonText="Edit" @action="edit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
    <Modal :modalVisible="visibleDeleteModal" @close="toggleDeleteModal" id="delete-modal">
      <template slot="modal-content">
        <div class=" text-cente mt-6 mb-4">Apakah Anda yakin akan menghapus partner ini?</div>
        <div class="flex justify-center items-center gap-4">
          <Button buttonText="Ya" @action="deletePartnerEntry()" type="secondary" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Tidak" @action="toggleDeleteModal()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button')
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    bankData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visibleDeleteModal: false
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    vehiclePartnerId() {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions('armada', ['deletePartner']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    toggleDeleteModal() {
      this.visibleDeleteModal = !this.visibleDeleteModal
    },
    edit() {
      this.$router.push(`/armada/partner/edit/${this.vehiclePartnerId}`)
    },
    deletePartnerEntry() {
      this.showLoading()
      this.deletePartner({
        partnerId: this.partnerId,
        vehiclePartnerId: this.vehiclePartnerId
      }).then(() => {
        this.toggleDeleteModal()
        this.hideLoading()
        this.$router.push('/armada/partner')
      })
    }
  }
}
</script>
